module.exports = __webpack_public_path__ + "static/70-22ce7e52b99737ef5796c227ca39e322.png";